import { useFormik } from "formik";
import * as Yup from "yup";

const useFormTipoActividad = (onSubmit, afterSubmit, initialValues, isEditMode) => {
  const validationSchema = Yup.object({
    title: Yup.string().required("Nombre del tipo de actividad es requerido"),
    description: Yup.string().required("La descripción es requerida"),
    status: Yup.boolean().required("El estado es requerido"),
  });

  // Valores iniciales completos
  const safeInitialValues = {
    title: "",
    description: "",
    status: true,
    ...initialValues,
  };

  return useFormik({
    initialValues: safeInitialValues,
    validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        await onSubmit(values);
        afterSubmit();
      } finally {
        setSubmitting(false);
      }
    },
    enableReinitialize: true,
  });
};

export default useFormTipoActividad;
